/**
 * Data Compare Feature Module
 *
 * Registers the data-compare workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the data-compare workspace component
registerWorkspaceComponent(
  'data-compare',
  lazyWorkspaceTab(() => import('./components/DataCompareTab').then((m) => ({ default: m.DataCompareTab }))),
);

// Re-export components
export { DataCompareSetupDialog } from './components/DataCompareSetupDialog';
